import React from 'react';

import { Banner } from '@bypasslane/clover--web-lib-sprout-banner';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getLatestMessage } from 'redux-flash';

export const FlashBanner = () => {
  const messages = useSelector((state) => getLatestMessage(state)) || []; // Add fallback
  const flashMessages = Array.isArray(messages) ? messages : [messages]; // Ensure it's an array

  return (
    <div className="flex justify-center items-center w-full">
      <div className="max-w-md w-full text-center min-h-[60px]">
        {flashMessages.map((flashMessage) => (
          <FlashBannerMessage
            key={flashMessage.id}
            message={flashMessage.message}
            isError={flashMessage.isError}
            props={flashMessage.props}
          />
        ))}
      </div>
    </div>
  );
};

const FlashBannerMessage = ({ message, isError, ...props }) => (
  <Banner
    className="mb-4"
    variant={isError ? 'error' : 'success'}
    ariaAtomic="true"
    ariaLive="polite"
    {...props}
  >
    <span>{message}</span>
  </Banner>
);

FlashBannerMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isError: PropTypes.bool,
  props: PropTypes.shape({
    closeable: PropTypes.bool
  })
};
FlashBannerMessage.displayName = 'FlashBannerMessage';

export default FlashBanner;
